// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: process.env.REACT_APP_apiKey,
  authDomain: process.env.REACT_APP_authDomain,
  projectId: process.env.REACT_APP_projectId,
  storageBucket: process.env.REACT_APP_storageBucket,
  messagingSenderId: process.env.REACT_APP_messagingSenderId,
  appId:process.env.REACT_APP_appId 
  /*
  apiKey: "AIzaSyASuCuiT3OOR6m2OAfwr_93Xddk1ExTi3c",
  authDomain: "assignment-11-client-5c08c.firebaseapp.com",
  projectId: "assignment-11-client-5c08c",
  storageBucket: "assignment-11-client-5c08c.appspot.com",
  messagingSenderId: "786989675596",
  appId: "1:786989675596:web:c565f70a48e3fa5f4c30e9"
  */
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export default app;